import React from "react";
import DynamicInsightShare from "components/InsightShare/DynamicInsightShare";
import styles from "./ArticleMainContent.module.scss";

interface Props {
  children: React.ReactNode;
  sidebarContent: React.ReactNode;
  title: string;
  slug: string;
  urlOverride?: string;
}

const ArticleMainContent = (props: Props) => {
  return (
    <div className="row">
      <div className="col-xl-9 col-md-7">
        <div className={styles.ArticleMainContent__articleBody}>
          {props.children}
          <div className={styles.insightShare}>
            <DynamicInsightShare
              title={props.title}
              slug={props.slug}
              urlOverride={props.urlOverride}
            />
          </div>
        </div>
      </div>
      <div className="col-xl-3 offset-xl-0 col-md-4 offset-md-1">
        <div className={styles.sidebarContent}>{props.sidebarContent}</div>
      </div>
    </div>
  );
};

export default ArticleMainContent;
